import { useWebSocketHandler } from '@utils/graphql/setup';
import { getConfig } from '@utils/config';

/**
 * Isolated component so that Apollo's useSubscription state (updated on every
 * WebSocket message) belongs here rather than to App. This prevents each
 * incoming socket event from re-rendering App and all its page children.
 */
function WebSocketHandler() {
  useWebSocketHandler();
  return null;
}

export function ConditionalWebSocketHandler() {
  if (getConfig().LIVE_UPDATES_ENABLED === 'false') return null;
  return <WebSocketHandler />;
}